
/* injects from baggage-loader */

'use strict';

import ProjectManagerActivityController from './projectmanager.activity.controller';
import ProjectManagerActivityTemplate from './projectmanager.activity.html';

export default class ProjectManagerActivityComponent {
		constructor() {
				this.templateUrl = ProjectManagerActivityTemplate;
				this.controller = ProjectManagerActivityController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					project: '<',
					events: '<'
				};
		}
}
